export type BooleanParseResult = {
  type: 'boolean';
  value: boolean;
};

/**
 * Detects `true` / `false` boolean literals.
 *
 * Returns null if the value string is not a boolean literal.
 */
export function parseBooleanType(valueStr: string): BooleanParseResult | null {
  if (valueStr !== 'true' && valueStr !== 'false') return null;
  return { type: 'boolean', value: valueStr === 'true' };
}
